<template>
  <div id="app">
    <layout>
      <keep-alive :include="cache">
        <router-view />
      </keep-alive>
    </layout>
  </div>
</template>
<script>
import layout from '@/components/layout.vue';
export default {
  components: {
    layout,
  },
  data() {
    return {
      cache: [],
    };
  },
};
</script>
<style lang="scss">
@import '@/common/css/index.scss';
</style>
